import React from 'react'
import '../../styles/page-heading.css';
import { useSelector } from 'react-redux';
const PageHeading = ({ heading }) => {
    const { isDark } = useSelector((state) => state.useReducer);
    return (
        <div className='container'>
            <div className='row'>
                <div className='col-12'>
                    <div className="header-container">
                        <h1 style={{ color: `${isDark ? "#3F51B5" : "#3F51B5"}` }}>{heading}</h1>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageHeading
